<template>
  <div>
    <nav-breadcrumb :menu="[{label :'放款记录'}]"/>
    <el-form label-width="170px" class="xzformitemmb" :model="financingDetail" ref="dataForm">
      <el-row>
        <panel title="贷款信息" border>


          <el-col :span="12">
            <el-form-item label="贷款人：">
              {{financingDetail.fi__customerName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="贷款编号 ：">
              {{financingDetail.fi__transactionNo}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="渠道商：">
              {{financingDetail.d__dealerName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="贷款金额：">
              {{financingDetail.fi__totalAmount|formatMoney}} 元
            </el-form-item>
          </el-col>
        </panel>
        <panel title="放款信息" border>
          <el-col :span="12">
            <el-form-item label="收款账号：">
              {{financingDetail.t__customerAccountNo}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="户名：">
              {{financingDetail.t__customerAccountName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行：">
              {{financingDetail.t__customerAccountBankName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="放款金额：">
              {{financingDetail.t__totalAmount|formatMoney}} 元
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="放款方式：" >
              {{financingDetail.t__channel|Status2CN}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="放款日期：" >
              {{financingDetail.pay__payDate|moment('YYYY-MM-DD')}}
            </el-form-item>
          </el-col>
            <el-col :span="24">
                <el-form-item label="放款银行：">
                    {{financingDetail.ba__accountName}}-{{financingDetail.ba__branch}}-{{financingDetail.ba__accountNo}}
                </el-form-item>
            </el-col>

          <el-col :span="24">
            <el-form-item label="放款流水号：">
              {{financingDetail.pay__reference}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="摘要：">
              {{financingDetail.pay__txUse}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="放款人：">
              {{financingDetail.z__check1By}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经办时间：">
              {{financingDetail.z__check1Time|moment('YYYY-MM-DD HH:mm:ss')}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="复核人：">
              {{financingDetail.z__check2By}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="复核时间：">
              {{financingDetail.z__check2Time|moment('YYYY-MM-DD HH:mm:ss')}}
            </el-form-item>
          </el-col>
        </panel>
      </el-row>
    </el-form>
    <div class="tr xzmt">
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {formatMoney} from "../../filters/CommonFilters";
  export default {
    name: "LoanRecordView",
    data() {
      return {
        financingDetail: {
        },
        balance:0,

      }
    },
    filters: {

      Status2CN
    },
    mounted(){
      this.getData()
     // this.GetAccountBalance()
    },
    methods:{
      getData:function () {
        xhr.getViewFinancingPayment({
            'fi.transactionId': this.$route.query['transactionId']
          },
          res => {
            try {
              if (res.data.status == 'success') {
                this.financingDetail = res.data.data
              }
            } catch (e) {

            }
          })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/LoanRecordView.vue